import AuthService from '../services/auth.service';
import VippsService from '../services/vipps.service';
// import CompetitionDataService from '../services/CompetitionDataService';

const localStorage_user = localStorage.getItem('store')
  ? JSON.parse(localStorage.getItem('store')).auth
  : undefined;
const initialState = localStorage_user
  ? {
    status: { loggedIn: localStorage_user.status.loggedIn },
    user: localStorage_user.user,
    roles: localStorage_user.roles == "undefined" ? undefined : localStorage_user.roles
  }
  : {
    status: { loggedIn: false },
    user: null,
    roles: null
  };

// const user = JSON.parse(localStorage.getItem('store')).auth;
// const initialState = user
//   ? { status: { loggedIn: true }, user, selectedCompetition: null }
//   : { status: { loggedIn: false }, user: null, selectedCompetition: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, { user, store }) {
      return AuthService.login(user, store).then(
        logindata => {
          commit('loginSuccess', logindata);
          return Promise.resolve(logindata);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    vippslogin({ commit }, code) {
      return VippsService.getUserInfo(code).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    vippsupdateauthorizationinfo({ commit }) {
      return VippsService.updateAuthorizationInfo().then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
      commit('SET_ROLES', undefined);
      commit('competition/SET_ACTIVE_COMPETITIONS', [], { root: true });
      commit('competition/SET_SELECTED_COMPETITION_ID', null, { root: true });
      commit('participant/SET_SELECTED_PARTICIPANT_ID', null, { root: true });
      // Redirect to login page or trigger logout
      this.$router.push('/login');
    },
    register({ commit }, user) {
      // console.log('test....');
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    },
    updateRoles({ commit }) {
      console.log("updateRoles - action");

      AuthService.getRoles()
        .then(response => {
          console.log("updateRoles - response: ");
          console.log(response);
          commit('SET_ROLES', response);
        })
        .catch(error => {
          console.log("updateRoles - error: " + error);
        }
      );
    },
    setRoles({ commit }, roles) {
      console.log("setRoles - action: ");
      console.log(roles);
      commit('SET_ROLES', roles);
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    SET_ROLES(state, roles) {
      state.user.roles = roles;
    }
  }
};

